import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Project, Investigation, RunSummary, RunManifest } from '@contracts/index';

export interface ProjectState {
  currentProject: Project | null;
  currentInvestigation: Investigation | null;
  activeRun: RunSummary | null;
  activeManifest: RunManifest | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ProjectState = {
  currentProject: null,
  currentInvestigation: null,
  activeRun: null,
  activeManifest: null,
  isLoading: false,
  error: null
};

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setCurrentProject: (state, action: PayloadAction<Project | null>) => {
      state.currentProject = action.payload;
    },
    setCurrentInvestigation: (state, action: PayloadAction<Investigation | null>) => {
      state.currentInvestigation = action.payload;
    },
    setActiveRun: (state, action: PayloadAction<RunSummary | null>) => {
      state.activeRun = action.payload;
    },
    setActiveManifest: (state, action: PayloadAction<RunManifest | null>) => {
      state.activeManifest = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    }
  }
});

export const {
  setCurrentProject,
  setCurrentInvestigation,
  setActiveRun,
  setActiveManifest,
  setLoading,
  setError
} = projectSlice.actions;

export default projectSlice.reducer;
